import fetchJSON from '@api/api_helper';

const url = 'https://logo-variation.brandfolder-svc.com/v1/logodiff';

export default (url_1, url_2) => (
  fetchJSON(url, {
    method: 'POST',
    body: {
      attachment: {
        url_1,
        url_2,
      },
    }
  }).then((response) => {
    const { similarity_score: score, percent_difference: difference } = response.score;
    return {
      score,
      difference,
    };
  })
);
